<template>
  <el-card :style="{width: '650px'}">
    <template slot="header">
      <el-button @click="download">Download</el-button>
    </template>
    <el-card shadow="never" ref="statement" id="statement" :style="{width: '600px', fontSize: '0.7rem'}">
      <el-header>
        <el-row>
          <el-col :span="10" :style="{textAlign: 'left'}">
            <h4>
              Readyspaces {{ this.$root.state.facilityData.title }}
            </h4>
            <div>
              {{ facilityStreetAddress }}
            </div>
            <div>
              {{ facilityAddress }}
            </div>
            <div>
              {{ facilityPhoneNumber }}
            </div>
          </el-col>
          <el-col :span="14" :style="{textAlign: 'right'}">
            <h2>Account Statement</h2>
            <div>
              Date: {{ now | formatDate }}
            </div>
          </el-col>
        </el-row>
        <br/>
        <el-row>
          <el-col :style="{textAlign: 'left'}">
            <div>
              Customer: {{ customer.company }}
            </div>
            <div>
              Balance: {{ accountBalance }}
            </div>
            <div>
              Rentals: {{ lease.unitRentalsInfo.map(unitRentalInfo => unitRentalInfo.name).join(', ') }}
            </div>
          </el-col>
        </el-row>
      </el-header>
      <el-main v-for="(item, index) in chunks" :key="item._id">
        <el-table
          :data="item" stripe border fit :cell-style="{padding: '0'}" :header-cell-style="{padding: '0'}"
          :style="{fontSize: '10px', marginBottom: '2.5em', ...(index === 0 ? { marginTop: '5px' } : { maringTop: '5px', marginBottom: '50px' }) }"
        >
          <el-table-column prop="createdAt" label="Date" :width="75">
            <template slot-scope="scope">
              {{ scope.row.createdAt | formatDate }}
            </template>
          </el-table-column>
          <el-table-column label="Description" :width="200" prop="description">
          </el-table-column>
          <el-table-column label="Charges" :width="75">
            <template slot-scope="scope">
              <div v-if="scope.row.type !== 'DEBIT'">
                {{ scope.row.amount | currencySign($root.state.facilityData) }}
              </div>
              <div v-else> - </div>
            </template>
          </el-table-column>
          <el-table-column label="Payment/voids" :width="100">
            <template slot-scope="scope">
              <div v-if="scope.row.type === 'DEBIT'">
                {{ -scope.row.amount | currencySign($root.state.facilityData) }}
              </div>
              <div v-else> - </div>
            </template>
          </el-table-column>
          <el-table-column label="Balance" :width="75" prop="accountBalance">
            <template slot-scope="scope">
              {{ scope.row.accountBalance | currencySign($root.state.facilityData) }}
            </template>
          </el-table-column>
        </el-table>
      </el-main>
    </el-card>
  </el-card>
</template>
<script>
import { jsPDF } from 'jspdf';

export default {
  name: 'AccountStatement',
  props: {
    balance: { type: String },
    units: { type: Array, default: () => [] },
    lease: { type: Object },
    customer: { type: Object, default: () => {} },
  },
  watch: {
    lease() {
      this.rawHtml = this.$refs.statement.$el.outerHTML;
      const lineItems = [...this.lease.lineItems].reverse();
      if (lineItems.length > 25) {
        const firstPageLineItems = lineItems.slice(0, 24);
        const remainingItems = lineItems.slice(25, lineItems.length);
        this.chunks = this.sliceIntoChunks(remainingItems, 30);
        this.chunks.unshift(firstPageLineItems);
      } else {
        this.chunks = [lineItems];
      }
    },
  },
  mounted() {
    this.rawHtml = this.$refs.statement.$el.outerHTML;
    const lineItems = [...this.lease.lineItems].reverse();
    if (lineItems.length > 25) {
      const firstPageLineItems = lineItems.slice(0, 24);
      const remainingItems = lineItems.slice(25, lineItems.length);
      this.chunks = this.sliceIntoChunks(remainingItems, 30);
      this.chunks.unshift(firstPageLineItems);
    } else {
      this.chunks = [lineItems];
    }

  },
  computed: {
    facilityPhoneNumber() {
      return `${this.$root.state.facilityData.manager.phone}`;
    },
    facilityStreetAddress() {
      return `${this.$root.state.facilityData.addressInfo.addressLine1}`;
    },
    facilityAddress() {
      return `${this.$root.state.facilityData.addressInfo.city}, ${this.$root.state.facilityData.addressInfo.pinCode}`;
    },
    accountBalance() {
      const value = this.lease.amount;
      const paid = this.lease.amountPaid;
      const balance = value - paid > 0 ? value - paid : 0;
      return this.$options.filters.currencySign(Number(balance), this.$root.state.facilityData);
    },
  },
  data() {
    return {
      now: new Date(),
      rawHtml: '',
      chunks: [],
    };
  },
  methods: {
    sliceIntoChunks(arr, chunkSize) {
      const res = [];
      for (let i = 0; i < arr.length; i += chunkSize) {
        const chunk = arr.slice(i, i + chunkSize);
        res.push(chunk);
      }
      return res;
    },
    download() {
      const doc = new jsPDF({
        unit: 'pt',
        format: 'a4',
        precision: 5,
      });
      const pdfElement = document.getElementById('statement');
      doc.html(pdfElement, {
        autoPaging: true,
        callback: function ( pdf ) {
        pdf.save('account-statement.pdf');
        },

      });
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AccountStatement.vue